import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { FundingFee } from "@Types/deal";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

import styles from "./UCC.module.scss";

const UCC = ({ uccFees }: { uccFees: FundingFee[] }) => {
  return (
    <Paper title="UCC">
      {uccFees.map((fee) => (
        <Grid
          container
          xs={12}
          key={fee.amount}
          className={styles.feeContainer}
        >
          <Grid xs={12}>{renderFieldData("Fee Amount", `${fee.amount}`)}</Grid>
          <Grid container xs={12}>
            <Grid xs={6} className={styles.label}>
              Attached Document
            </Grid>
            <Grid xs={6} className={styles.data}>
              <a
                href={fee?.document?.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open document
              </a>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};

export default UCC;
